module.exports = __webpack_public_path__ + "static/media/cta-mobile.ca7ffeaa.png";